/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '@/features/dialog/dialogSlice';
import CreateClientForm from '@/components/forms/CreateClientForm';
import { VIEW_TYPES } from '@/features/config/helper';
import UpdateClientForm from '@/components/forms/UpdateClientForm';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';

export const ClientDrawer = () => {
	const dispatch = useDispatch();

	const dialogData = useSelector((state) => state.dialog);
	const open = dialogData?.open?.clientDialog ?? false;
	const clientId = dialogData?.data?.clientDialog?.clientId;
	const type = dialogData?.data?.clientDialog?.view;

	const view = !clientId || !type ? VIEW_TYPES.create : type;

	// useEffect(
	// 	() => console.log('Dialog data', { data: dialogData?.data, view, clientId, type }),
	// 	[view, clientId, dialogData?.data, type],
	// );

	const handleClose = () => {
		dispatch(closeDialog('clientDialog'));
	};

	const handleSubmit = async (newClientId) => {
		handleClose();
	};

	const ClientForm = useCallback(
		({ ...props }) =>
			view === VIEW_TYPES.create ? (
				<CreateClientForm {...props} />
			) : (
				<UpdateClientForm {...props} />
			),
		[view],
	);

	return (
		<FolioDrawer open={open} onClose={handleClose} canMaximise>
			{open && <ClientForm dialogView={true} onSubmit={handleSubmit} />}
		</FolioDrawer>
	);
};
